<template>
  <div class="container-fluid" ref="container">
    <div class="col-sm-12 col-md-8 offset-md-2">
      <div class="panel">
        <div class="panel-heading">
          <div class="panel-label">
            <h3 class="header"> Analytics - Date range </h3>
          </div>
          <div class="panel-toolbar">
            <!--<a class="btn btn-sm btn-primary" href="/">Clear</a>-->
          </div>
        </div>
        <div class="panel-body">
          <date-range-picker @dateChanged="dateChanged" :dateRange="getDateRange">
          </date-range-picker>
        </div>
      </div>
      <div class="panel">
        <div class="panel-heading">
          <div class="panel-label">
            <h3 class="header"> Analytics - Shops </h3>
          </div>
          <div class="panel-toolbar">
            <!--<a class="btn btn-sm btn-primary" href="/">Clear</a>-->
          </div>
        </div>
        <div class="panel-body">
          <div class="row" id="select-shop">
            <div class="col-12">
              <div class="key-account-box" v-if="getUser.role === 'admin' && getUserChilds">
                <key-account-picker @changeUser="changeUser" :currentUser="currentKeyAccount"></key-account-picker>
                <div class="btn-group">
                  <button type="button" class="btn btn-primary btn-sm mt-4" v-if="key_account" v-on:click="selectShops({ showAll: key_account.id })">Show all</button>
                  <!--<button type="button" class="btn btn-warning btn-sm" v-if="key_account && getUser.role === 'admin'" v-on:click="selectShopsConversion({ showAll: true })">Show all (Coversion)</button>-->
                </div>
              </div>
            </div>

            <div class="col-12 pt-md-4">
                <vue-table ref="table"
                            :useBulk="false"
                            :dataTable="getShopsIncludingFilters"
                            :selectedRows="selectedShops"
                            :defaultSortOrder="[getShopsTableSortOrder]"
                            :tableFields="shopsTableFields"
                            :useSearch="useSearch"
                            :page="page"
                            :perPage="perPage"
                            :slots="slots"
                            :filters="getShopsTableFilters"
                            @currentPage="SetShopsTablePage($event)"
                            @onSearch="onSearch"
                            @currentData="newCurrentData"
                            >
                    <template slot="bulk">
                        <input type="checkbox" v-model="bulk" @change="bulkSelect($event)">
                    </template>

                    <template slot="select" slot-scope="props">
                        <input type="checkbox" v-model="props.data.toAnalyze">
                    </template>
                </vue-table>
            </div>
          </div>
        </div>

        <div class="panel-footer">
          <div class="btn-group">
            <button type="button" class="btn btn-primary mr-3" v-if="getUser.role === 'key_account'" v-on:click="selectShops({ showAll: getUser.id })">Show all</button>
            <button type="button" class="btn btn-primary btn-sm mr-2" v-on:click="selectShops({ showAll: false })">Show selected</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions, mapMutations } from 'vuex';

import Table from '../../../components/Panel/Table/Table';
import KeyAccountPicker from '../../../components/Shared/KeyAccountPicker/KeyAccountPicker';
import DateRangePicker from '../../../components/Shared/Datepicker/DateRangePickerKibana.vue';
import moment from 'moment';

export default {
    name: 'AnalyticsView',
    data () {
        return {
            firstLoad: true,
            kibanaDimensions: null,
            loaded: false,
            time: undefined,
            currentKeyAccount: undefined,
            selectedShopsPart: {
                online: [],
                offline: []
            },
            useSearch: true,
            selectedShops: [],
            bulk: true,
            perPage: 1,
            shopsTableFields: [
                {
                    name: 'select',
                    title: 'Select'
                },
                {
                    name: 'name',
                    title: 'Shop name',
                    sortField: 'name',
                    propName: 'name'
                },
                {
                    name: 'address.country',
                    title: 'Country',
                    sortField: 'address.country',
                    propName: 'country'
                },
                {
                    name: 'address.city',
                    title: 'City',
                    sortField: 'address.city',
                    propName: 'city'
                },
                {
                    name: 'externalID',
                    title: 'External ID',
                    sortField: 'externalID',
                    propName: 'externalID'
                }
            ],
            currentData: [],
            slots: [
                {name: 'select' }
            ]
        };
    },
    computed: {
        filteredListPopulated () {
            return this.orders.length > 0;
        },
        ...mapGetters({
            getDateRange: 'getDateRange',
            getShops: 'getShops',
            key_account: 'getAll',
            getUserChilds: 'getUserChilds',
            getUser: 'getUser',
            getToken: 'getToken',
            getShopsTableFilters: 'getShopsTableFilters',
            page: 'getShopsTablePage',
            getShopsTableSortOrder: 'getShopsTableSortOrder',
            getEitherDisabledShops: 'getEitherDisabledShops',
            getShopsIncludingFilters: 'getShopsIncludingFilters'
        })
    },
    watch: {
        getShops (newVal, oldVal) {
            if(newVal.length != oldVal.length || !oldVal.length || oldVal.length === 0 || this.firstLoad){
                newVal = newVal.map(shop=> {
                    shop.toAnalyze = false;
                    return shop;
                });
                this.firstLoad = false;
            }
            this.SetShopsIncludingFilters(newVal);
        },
        searchAll (newVal, oldVal) {
            this.searchAll = newVal;
            this.setEitherDisabledShops(this.searchAll);
            //this.GetAllShops(this.currentKeyAccount ? this.currentKeyAccount.id : undefined)
        }
    },
    methods: {
        dateChanged (value){
            this.time = value;
            this.changeDate(this.time);
        },
        selectShops ({ showAll }){
            const toAnalyzeShops = this.getShopsIncludingFilters.filter((shop) => {
                return shop.toAnalyze;
            });
            const toAnalyzeShopsIds = toAnalyzeShops.map((shop) => {
                return shop.id;
            });


            this.changeShops(toAnalyzeShopsIds);
            this.PostKibanaSettings({ token: this.getToken, showAll: showAll })
                .then((data) => {
                    this.$router.push({ name: 'analytics-show' });
                })
                .catch(error => {
                    this.$message.error(error.error.message);
                });
        },
        ...mapActions([
            'GetAllShops',
            'SetShopsIncludingFilters',
            'AddShopsTableFilters',
            'SetShopsTablePage',
            'PostKibanaSettings',
            'changeDate',
            'changeShops',
            'changeAll',
            'changeSession',
            'getConversionData'
        ]),
        ...mapMutations([
            'setActiveKeyAccount'
        ]),
        showShopsModal (){
            this.$modal.show('select-shops');
        },
        hideShopsModal (){
            this.$modal.hide('select-shops');
        },
        showDateModal (){
            this.$modal.show('select-date');
        },
        async changeUser (key_account) {
            this.changeAll(key_account);
            //await this.setActiveKeyAccount(key_account);
            this.currentKeyAccount = key_account;
            await this.GetAllShops(key_account ? key_account.id : undefined);
        },
        handleResize (){
            let {container} = this.$refs;
            let {width} = container.getBoundingClientRect();
            let height = window.innerHeight;
            this.kibanaDimensions = { width, height};
        },
        bulkSelect: function (event){
            const start = (this.page-1)*this.perPage;
            const end = this.page*this.perPage;
            let counter = start;
            for(const i in this.currentData){
                this.currentData[i].toAnalyze = this.bulk ? true : false;
            }
        },
        newCurrentData: function (data){
            this.currentData = data;
            let b = true;
            for(const i in data){
                if(!data[i].selected){
                    b = false;
                    break;
                }
            }
            this.bulk = b;
        },
        onSearch (data) {
            this.AddShopsTableFilters(data);
            this.SetShopsIncludingFilters(this.getShops);
        }
    },
    components: {
        'key-account-picker': KeyAccountPicker,
        'vue-table': Table,
        DateRangePicker
    },
    mounted () {
        this.time = this.getDateRange; //FIX THIS
        let {container} = this.$refs;
        let {width} = container.getBoundingClientRect();
        let height = window.innerHeight;
        this.width = window.innerWidth;
        this.kibanaDimensions = {width, height};
        this.loaded = true;

        this.AddShopsTableFilters({
            name: {
                value: '',
                field: 'name',
                placeholder: 'Search Name'
            },
            country: {
                value: '',
                field: 'address.country',
                placeholder: 'Search Country'
            },
            city: {
                value: '',
                field: 'address.city',
                placeholder: 'Search City'
            },
            externalID: {
                value: '',
                field: 'externalID',
                placeholder: 'External ID'
            }
        });
    },
    created () {
        this.searchAll = this.getEitherDisabledShops;
        this.SetShopsIncludingFilters(this.getShops);
        if(this.getDateRange.length === 0){
            this.time = [moment().subtract(1, 'days'), moment()];
            this.changeDate(this.time);
        }
        window.addEventListener('resize', this.handleResize);
    },
    destroyed () {
        window.removeEventListener('resize', this.handleResize);
    }
};

</script>

<style lang="scss" scoped>
    .btn-tertiary {
        background: #bbb;
        color: #fff;
        font-size: 14px;
    }
</style>
